import type { PageLoad } from './$types';
import { getUser, getUserClasses } from '$lib/api/users';
import { error } from '@sveltejs/kit';
import type { SvelteFetch, UserClassSummary } from '$lib/api/types';

async function getInstructorClasses(id: number, fetch: SvelteFetch): Promise<UserClassSummary[]> {
      // a class will appear twice in the getUserClasses if they are an instructor of multiple clinical groups in the
      // same class. we need to combine them and remove the duplicate classes.
      let classes = await getUserClasses(id, false, fetch);
      const clinicalGroupNames: Record<number, string[]> = {};
      let reduced: UserClassSummary[] = [];

      for (let clazz of classes) {
        if (clinicalGroupNames[clazz.classId] !== undefined) {
          clinicalGroupNames[clazz.classId].push(clazz.clinicalGroupName);
        } else {
          reduced.push(clazz);
          clinicalGroupNames[clazz.classId] = [clazz.clinicalGroupName];
        }
      }

      for (let clazz of reduced) {
        clazz.clinicalGroupName = clinicalGroupNames[clazz.classId].join(', ');
      }

      return reduced;
    }

export const load: PageLoad = ({ params, fetch }) => {
  if (!params.id) error(404);
  const id = parseInt(params.id);
  if (isNaN(id)) error(404);
  const user = getUser(id, fetch);
  return {
    userPromise: user,
    classesPromise: getInstructorClasses(id, fetch),
    meta: {
      title: 'Instructor',
      activeNav: 'users',
      breadcrumbs: {
        activeTitle: user.then(u => `${u.lastName}, ${u.firstName}`),
        items: [
          {
            title: 'Users',
            href: '/admin/users',
          },
          {
            title: 'Instructors',
            href: '/admin/users/instructors',
          },
        ],
      },
    },
  };
};
